import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { downloadBlobAsFile, generateCSVContent } from '@/components/DownloadCsv/utils'

import { ActionMenuItem } from '../ActionMenuItem/ActionMenuItem'
import { useActionMenuContext } from '../context/ActionMenuContext'

export type ActionMenuExportToCSVItemProps<Data extends Record<string, unknown>> = {
  csvFileName?: string | ((row: Data) => string)
  csvHeaders?: string[]
  formatCsvRow?: (row: Data) => string[]
}

export const ActionMenuExportToCSVItem = <Data extends Record<string, unknown>>({
  csvFileName,
  csvHeaders,
  formatCsvRow
}: ActionMenuExportToCSVItemProps<Data>) => {
  const { row, closeMenu } = useActionMenuContext<Data>()

  const exportToCsv = () => {
    const csvContent = generateCSVContent({
      headers: csvHeaders,
      data: [row],
      formatCsvRow
    })

    let fileName = 'export.csv'
    if (typeof csvFileName === 'function') {
      fileName = csvFileName(row) + '.csv'
    } else if (typeof csvFileName === 'string') {
      fileName = csvFileName.endsWith('.csv') ? csvFileName : csvFileName + '.csv'
    }
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    downloadBlobAsFile(blob, fileName)
    closeMenu?.()
  }

  return (
    <ActionMenuItem
      text="Export To CSV"
      icon={<FileDownloadOutlinedIcon />}
      onClick={exportToCsv}
    />
  )
}
